var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{'is-selected': _vm.selected},on:{"click":_vm.onClick}},[_vm._t("default"),_c('app-icon',{staticClass:"item-chevron",attrs:{"icon":"chevron.right"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }